import {SessionService} from './../../../services/session';
import {TabsPage} from './../../tabs/tabs';
import {BackendModule} from './../../../modules/backend.module';
import {NavController, Platform} from 'ionic-angular';
import {Component} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {LocationsService} from '../../../services/locations';


@Component({
  selector: 'page-policy',
  templateUrl: 'policy.html',
})
export class PolicyPage {
  tabsPage = TabsPage;
  safeURL: any;

  constructor(private backendModule: BackendModule,
              public navCtrl: NavController,
              public sessionService: SessionService,
              public sanitizer: DomSanitizer,
              public platform: Platform,
              public locationsService: LocationsService) {
    var urlToLoad: string = locationsService.translate('url') + 'terminosycondiciones';
    this.safeURL = sanitizer.bypassSecurityTrustResourceUrl(urlToLoad)
  }

  public unregisterBackButtonAction: any;

  ionViewDidLoad() {
    this.initializeBackButtonCustomHandler();
    window['page'] = 'PolicyPage'; // for GA
  }

  ionViewWillLeave() {
    // Unregister the custom back button action for this page
    this.unregisterBackButtonAction && this.unregisterBackButtonAction();
  }

  initializeBackButtonCustomHandler(): void {
    // Priority 101 will override back button handling (we set in app.component.ts) as
    // it is bigger then priority 100 configured in app.component.ts file */
    this.unregisterBackButtonAction = this.platform.registerBackButtonAction(function (event) {}, 101);
  }

  agreeToPolicy() {
    let userId = this.sessionService.user.id;
    this.backendModule.putAPI(`users/${userId}`,
      {
        user: {policy_version: this.sessionService.user.policy_version.required}
      }).subscribe(
      () => {
        this.navCtrl.setRoot(this.tabsPage);
      },
      (err) => {
        this.sessionService.reportError('policyPage', 'agreeToPolicy()', err);
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/policy/policy.ts